var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_14484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1618 6.15593C21.3984 6.49362 20.5888 6.7154 19.7598 6.81393C20.6336 6.29136 21.2875 5.46894 21.5998 4.49993C20.7798 4.98793 19.8808 5.32993 18.9438 5.51493C18.3144 4.84151 17.4802 4.39489 16.5708 4.24451C15.6614 4.09413 14.7277 4.24842 13.9151 4.68338C13.1024 5.11834 12.4562 5.80961 12.0769 6.64972C11.6976 7.48983 11.6066 8.43171 11.8178 9.32893C10.1549 9.24558 8.52814 8.81345 7.0431 8.06059C5.55805 7.30773 4.24794 6.25097 3.19781 4.95893C2.8261 5.59738 2.63076 6.32315 2.63181 7.06193C2.63181 8.51193 3.36981 9.79293 4.49181 10.5429C3.82782 10.522 3.17844 10.3427 2.59781 10.0199V10.0719C2.59801 11.0376 2.93218 11.9735 3.54366 12.721C4.15513 13.4684 5.00629 13.9814 5.95281 14.1729C5.33642 14.34 4.69012 14.3646 4.06281 14.2449C4.32968 15.0762 4.84982 15.8031 5.5504 16.324C6.25099 16.8449 7.09694 17.1337 7.96981 17.1499C7.10229 17.8313 6.10899 18.3349 5.04669 18.6321C3.98439 18.9293 2.87394 19.0142 1.77881 18.8819C3.69051 20.1114 5.9159 20.764 8.18881 20.7619C15.8818 20.7619 20.0888 14.3889 20.0888 8.86193C20.0888 8.68193 20.0838 8.49993 20.0758 8.32193C20.8947 7.73009 21.6014 6.99695 22.1628 6.15693L22.1618 6.15593Z",
    fill: "#96ACBC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_14484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24px",
    height: "24px",
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.1d3d843cf350c143bd753a0f6a164853.svg";
export { ForwardRef as ReactComponent };